import {
  createContext,
  Context,
} from 'react';

export const PaymentContext: Context<{}> = createContext({});

export const PaymentProvider = (props: any) => {
  const { value } = props;

  return (
    <PaymentContext.Provider value={value}>
      {props.children}
    </PaymentContext.Provider>
  );
};